import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

export interface IChecker {
    checked: boolean;
}

export const Checker: React.FC<IChecker> = (props) => {
    const { checked } = props;

    return (
        <figure
            className={`mx-auto flex h-5 w-5 items-center justify-center rounded-full p-1 md:h-10 md:w-10 ${
                checked ? 'bg-primary' : 'bg-neutral-700'
            }`}
        >
            {checked && <CheckIcon className={`h-3 text-white md:h-5`} />}
        </figure>
    );
};
